export default __webpack_public_path__ + "static/media/Hamburger.3f8478a3.svg";